import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { TranslateLabelPipe } from 'src/app/core/pipes/translate-label.pipe';
import { FilterConfig, FiltersService } from './filters.service';
import { NavService } from 'src/app/core/providers/services/nav.service';

@Component({
  selector: 'app-filters',
  templateUrl: './filters.component.html',
  providers: [TranslateLabelPipe],
  standalone: false,
})
export class FiltersComponent implements OnInit {
  constructor(
    public translateService: TranslateService,
    public route: ActivatedRoute,
    public router: Router,
    public filtersService: FiltersService,
    protected navService: NavService
  ) {}

  ngOnInit() {
    this.navService.pageTitle = this.translateService.instant(
      'main.page_titles.filters'
    );
    this.navService.showBackButton = true;
    this.navService.showSearchbar = false;
    this.navService.showFilters = false;
  }

  public onClick = (data: FilterConfig) => {
    this.router.navigate(['filters', data.CodeName]);
  };
}
